import * as React from "react";

const SvgComponent = (props:any) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M18.857 22H3.143C1.362 22 0 20.9 0 19.462V2.538C0 1.1 1.362 0 3.143 0h15.714C20.638 0 22 1.1 22 2.538v16.924C22 20.9 20.638 22 18.857 22z"
                fillOpacity={0}
                fill="#FFF"
            />
            <path
                d="M16 6L5.5 11.5M17 11L6.5 16.5"
                stroke="#444F5C"
                strokeWidth={3}
                strokeLinecap="square"
            />
        </g>
    </svg>
);

export default SvgComponent;